import types from 'redux/types';

const getListCreative = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_LIST_CREATIVE,
  };
};

const createCreative = (data) => {
  return {
    ...data,
    type: types.REQUEST_CREATE_CREATIVE,
  };
};

const updateCreative = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPDATE_CREATIVE,
  };
};

const deleteCreative = (data) => {
  return {
    ...data,
    type: types.REQUEST_DELETE_CREATIVE,
  };
};

const getCreativeById = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_CREATIVE_BY_ID,
  };
};

/** CAMPAIGN_CREATIVE */

const getCreativeByIdInCampaign = (data) => {
  return {
    ...data,
  };
};

const createCreativeInCampaign = (data) => {
  return {
    ...data,
  };
};

const updateCreativeInCampaign = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPDATE_CREATIVE_CAMPAIGN,
  };
};

const deleteCreativeInCampaign = (data) => {
  return {
    ...data,
  };
};

const getCreativeByCampaignId = (data) => {
  return {
    ...data,
  };
};

const uploadAttachments = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPLOAD_ATTACHMENTS_CREATIVE,
  };
};

const deleteAttachment = (data) => {
  return {
    ...data,
    type: types.REQUEST_DELETE_ATTACHMENT,
  };
};

const updateStatusContactGroup = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPDATE_STATUS_CONTACT_GROUP,
  };
};

export default {
  updateStatusContactGroup,
  getCreativeByIdInCampaign,
  createCreativeInCampaign,
  updateCreativeInCampaign,
  deleteCreativeInCampaign,
  getCreativeByCampaignId,
  updateCreative,
  deleteCreative,
  getListCreative,
  getCreativeById,
  createCreative,
  uploadAttachments,
  deleteAttachment,
};
